module.exports = __webpack_public_path__ + "static/VSCO-9f60ee60a59e5276f185145313abf9aa.png";